import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { PaymentService } from 'src/app/services/payment.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LanguajeService } from 'src/app/services/languaje.service';
import { AlertService } from 'src/app/services/shared/alert.service';
import { InAppPurchase2, IAPProduct } from '@ionic-native/in-app-purchase-2/ngx';//testpago
import { environment } from 'src/environments/environment';
import { TermsPolicyDialogComponent } from '../../components/terms-policy-dialog/terms-policy-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/shared/storage.service';

@Component({
  selector: 'app-pricing-modal',
  templateUrl: './pricing-modal.page.html',
  styleUrls: ['./pricing-modal.page.scss'],
})
export class PricingModalPageComponent implements OnInit {
  public VERSION_ILLUNOTES = environment.versionIlluNotes;

  /**Atributo que contiene la estructura de los planes de Play Console */
  products: IAPProduct[] = [];//testpago
  isMobile: boolean;

  plansMonthly = [];
  plansYearly = [];

  toggleCheck: boolean;

  // Data passed in by componentProps Modal
  @Input() showCurrentPlan: any;
  private _unsubscribeAll: Subject<any>;
  constructor(
    public modalController: ModalController,
    public changeDetector: ChangeDetectorRef,
    private paymentService: PaymentService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private languajeService: LanguajeService,
    public alertService: AlertService,
    private store: InAppPurchase2,//testpago
    private alertController: AlertController,
    public plt: Platform,
    public dialog: MatDialog
  ) {
    this._unsubscribeAll = new Subject();
    if (this.plt.is('mobile')) {
      this.isMobile = true;
    }
  }

  token: any;
  ngOnInit() {
    this.storageService.get('token').then((token) => {
      this.token = token;
      this.getAllPlans()
    });
  }

  ionViewDidEnter() {
    this.languajeService.languaje
      .subscribe(l => {
        this.translateService.use(l);
      });
  }

  ionViewWillLeave() {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getPlanFreeDays(plan) {
    return plan.features.find(f => f.label.includes('Free days')).value;
  }

  public validarAccionPago(product): void {
    const freeDays = this.getPlanFreeDays(product);
    this.goPayment(product.id_plan, freeDays);
  }

  countPopUp = 0;
  setupListeners() {
    // General query to all products
    this.store.when('product')
      .approved((p: IAPProduct) => {
        this.countPopUp += 1;
        if (this.countPopUp <= 1) {
          this.presentAlert(
            this.translateService.instant('COMPRA EXITOSA TITULO'),
            this.translateService.instant('COMPRA EXITOSA MOBILE')
          );
          this.dismiss();
        }
        this.changeDetector.detectChanges();
        return p.verify();
      })
      .verified((p: IAPProduct) => p.finish());



  }

  //PURCHASE MOBILE
  purchase(product: IAPProduct) {
    this.store.order(product).then(() => {
      //todo: missing handler
    }, e => {
      this.presentAlert('Failed', `Failed to purchase: ${e}`);
    });
  }

  async presentAlert(header, message) {
    const alert = await this.alertController.create({
      header,
      message,

      buttons: ['OK']
    });
    await alert.present();
  }

  loading: boolean;
  getAllPlans() {
    this.loading = true;
    this.paymentService.getAllPlans(this.token)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.loading = false;
          res.data.forEach(plan => {
            const planInfo = this.buildPlanInfo(plan);
            if (planInfo.periodicity == "month") {
              this.plansMonthly.push(planInfo)
            } else if (planInfo.periodicity == "year") {
              this.plansYearly.push(planInfo)
            }
          });
        } else {
          this.loading = false;
          this.alertService.presentToast(this.translateService.instant('ERROR PLANES'), 6000);
        }
      })
  }

  buildPlanInfo = (plan) => {
    return {
      id_plan: plan.id_plan,
      title: plan.title,
      price: plan.price,
      periodicity: plan.periodicity,
      quota: plan.quota,
      stripe_id: plan.stripe_id,
      type: plan.type,
      institutional: plan.institutional,
      features: [
        {
          value: plan.participant_only,
          label: "Participant only"
        },
        {
          value: plan.web_app,
          label: "Web app"
        },
        {
          value: plan.join_presentations,
          label: "Join presentations"
        },
        {
          value: plan.own_presentations,
          label: "Own presentations"
        },
        {
          value: plan.speaker_presentations,
          label: "Speaker presentations"
        },
        {
          value: plan.view_documents,
          label: "View documents"
        },
        {
          value: plan.documents_upload,
          label: "Documents upload"
        },
        {
          value: plan.free_days,
          label: `${plan.free_days} Free days`
        }
      ]
    };
  }

  changeToggle(ev) {
    this.toggleCheck = ev.detail.checked
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  loadSessionPayment: boolean;
  goPayment(id_plan, free_days) {
    /*this.modalController.dismiss({
      'dismissed': true
    });*/
    this.loadSessionPayment = true;
    this.paymentService.createCheckoutSession(this.token, id_plan, free_days)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        if (res.status == 200) {

          window.location.href = res.checkout_session.url;
          this.loadSessionPayment = false;
        } else if (res.status == 400 && res.type == "SUBSCRIPTION_ALREADY_ACTIVE") {
          this.createPortalAdminFromUser();
        } else {
          this.alertService.presentToast(this.translateService.instant('NO SESION PAGO'), 3000);
          this.loadSessionPayment = false;
        }
      }, (err) => {
        if (err.error.status == 400 && err.error.error.type == "SUBSCRIPTION_ALREADY_ACTIVE") {
          this.createPortalAdminFromUser();
        } else {
          this.loadSessionPayment = false;
          this.alertService.presentToast(this.translateService.instant('NO SESION PAGO'), 3000);
        }
      });
  }

  createPortalAdminFromUser() {
    this.loadSessionPayment = true;
    this.paymentService.createPortalSession(this.token)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        if (res.status == 200) {
          // console.log('check out session', res.session.url)
          window.location.href = res.session.url;
        } else {
          this.alertService.presentToast(this.translateService.instant('NO PORTAL PAGO'), 3000);
        }
        this.loadSessionPayment = false;
      }, () => {

        this.loadSessionPayment = false;
        this.alertService.presentToast(this.translateService.instant('NO PORTAL PAGO'), 3000);

      });
  }

  /**
   * 
   * @param typeAction terms or policy
   */
  termsAndConditions(typeAction: string) {
    this.dialog
      .open(TermsPolicyDialogComponent, {
        disableClose: true,
        data: {
          acceptButton: false,
          type: typeAction
        },
        //width: '80%',
        panelClass: 'terms-dialog'
      })
      .afterClosed()
      .subscribe((confirmado: boolean) => {
        if (confirmado) {
          //todo: missing handler
        } else {
          //todo: missing handler
        }
      });
  }
}
